import styled from 'styled-components';
import { Flex } from '@magalu/stereo-ui/atoms';
import { getBackgroundColor, getTextColor } from '@magalu/stereo-ui-styles';
import { Icon as StereoIcon } from '@magalu/stereo-ui-icons';
export const Container = styled(Flex).attrs(() => ({
  fontSize: 0,
  borderRadius: 4,
  fontWeight: '600',
  padding: '2px 4px'
}))`
  width: fit-content;
  align-items: center;
  background-color: ${getBackgroundColor('limeGreen')};
`;
export const Icon = styled(StereoIcon).attrs(() => ({}))`
  color: ${getTextColor('dark')};
`;